import React ,  { useState } from 'react'

import { SvgIcon } from "@progress/kendo-react-common";
import { plusCircleIcon } from "@progress/kendo-svg-icons";

import CustomSplitter from '../../../components/splitter/splitter'

import GenericGrid from '../../../components/grid/grid';
import { renderColumns } from '../../../utils/helper';




const styles = {
  container: {
    padding: "10px",
    backgroundColor: "#ffffff",
    lineHeight: "1.7",
    color: "#2c3e50"
  },
  sectionTitle: {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "20px",
    borderBottom: "2px solid #e5e7eb",
    paddingBottom: "8px",
    letterSpacing: "0.5px"
  },
  subTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "25px",
    marginBottom: "12px",
    color: "#34495e"
  },
  paragraph: {
    fontSize: "15px",
    textAlign: "justify",
    color: "#4b5563"
  }
};

const Document = () => {
  return (
    <div style={styles.container}>
      <h3 style={styles.sectionTitle}>7. ANALYSIS POPULATIONS</h3>

      <h4 style={styles.subTitle}>7.1. Safety Population</h4>

      <p style={styles.paragraph}>
        All subjects receiving FPV or FPV/RTV at any dose will be included in
        the safety population. Safety events will be summarized in two groups:
        those reported cumulatively throughout the study and those reported
        after 05July2011 until study completion (EoS). The EoS population
        continuing in the study following the July 5 2011 cut-off date will be
        the primary population for any safety analyses in this amended RAP and
        all cumulative safety events will be listed for this study.
      </p>
    </div>
  );
};





const dData = [
    {
        id:"1",
        name:"Safety Population",
        Abbreviation:"SAF",
        Description:"All subjects receiving FPV or FPV/RTV at any dose",
        Treatment:"as-treated",
        Usage:"Safety summaries/listings (cumulative throughout study; and events after 05July2011 through end of study)"
    },
    {
        id:"2",
        name:"Baseline Virology Population",
        Abbreviation:"BVP",
        Description:"All enrolled subjects with Day 1 (Baseline) data or Screening HIV resistance testing data",
        Treatment:"as-treated",
        Usage:"Virology analyses (baseline virology/resistance testing)"
    },
    {
        id:"3",
        name:"Virological Failure Population",
        Abbreviation:"VFP",
        Description:"Subjects meeting confirmed virologic failure criteria (based on HIV-1 RNA thresholds/rebound rules) for the relevant analysis window (Week 24, Week 48, or after Week 48 through end of study).",
        Treatment:"as-treated",
        Usage:"Primary population for genotypic and phenotypic resistance analyses; disposition summaries of confirmed virologic failure by Week 48 vs after Week 48 through end of study"
    },
    {
        id:"4",
        name:"",
        Abbreviation:"",
        Treatment:"",
        Description:"",
        Usage:""
    },
  
]


const BottomGrid = ()=>{
     const [dataState, setDataState] = useState({
      skip: 0,
      take: 100,
      sort: [],
      filter: null
    });

    const [ data , setData ] = useState( dData )

    const handleDataStateChange = (e) => {
       setDataState(e.dataState);
    };

    const col = [
    {
        cell:({dataIndex})=>{
          if( dataIndex == data.length - 1 )
            return  <td style={{padding:"0" ,textAlign:"center"}}> <SvgIcon icon={plusCircleIcon} size="medium" /></td>
          return <td style={{padding:"0" ,textAlign:"center"}}>{ dataIndex + 1 }</td>
        },
        title:"",
        width:30
    },
    {
        title:"Name",
        field:"name",
    },
    {
        title:"Abbreviation",
        field:"Abbreviation",
    },
    {
        title:"Description",
        field:"Description",
    },
    {
        title:"Treatment",
        field:"Treatment",
    },
    {
        title:"Usage",
        field:"Usage",
    },
]
  return (
             <GenericGrid
               data={data}
               columns={renderColumns(col)}
               dataState={dataState}
               onDataStateChange={handleDataStateChange}
               pageable={false}
               sortable={false}
               filterable={false}
              style={{ height:"70vh" , width:"100%"  }}
               dataItemKey = { "id" }
              selectable={{
                        enabled: false,
                        mode: "single",
                        drag: false,
                        cell: false}}
               onSelectionChange={()=>{}}
               selectedRow = {null}
               storageField = {""}
               />
  )
}



const AnalysisSet = () => {
  return (
    <div className='analysis-set-con'>
         <CustomSplitter orientation="vertical"  style = { { width:"100%" , height:"86vh"  , padding:"0px" , margin:"0px"}}>
              <Document/>
              <div style={{marginTop:"5px"}}>  
                <BottomGrid/>
              </div>
         </CustomSplitter>
    </div>
  )
}

export default AnalysisSet